import React from "react";
import { Text, TextField, Select, IconButton } from "@radix-ui/themes";
import { ArrowRightIcon } from "@radix-ui/react-icons";
import {
  SEVENROOMS_SOURCE_FIELDS,
  normalizeSevenRoomsFieldMappings,
  sevenRoomsFieldLabel,
} from "./sevenroomsFieldMappings";
import "./sevenroomsLayout.css";

function PairRow({ left, right }) {
  return (
    <div className="sr-pair">
      <div className="sr-pair__col">{left}</div>
      <div className="sr-pair__arrow">
        <IconButton size="2" variant="ghost" color="gray" style={{ pointerEvents: "none" }}>
          <ArrowRightIcon width="16" height="16" />
        </IconButton>
      </div>
      <div className="sr-pair__col">{right}</div>
    </div>
  );
}

export function SevenRoomsDataFieldsSection({ fieldMappings }) {
  const mappings = normalizeSevenRoomsFieldMappings(fieldMappings);

  return (
    <div className="sr-stack">
      <div className="sr-pair sr-pair--head">
        <Text size="2" weight="medium">b connect</Text>
        <span className="sr-pair__arrow" />
        <Text size="2" weight="medium">SevenRooms</Text>
      </div>

      <PairRow
        left={
          <TextField.Root variant="surface" value="Email address" size="2" disabled style={{ width: "100%" }} />
        }
        right={
          <Select.Root value="email" disabled size="2">
            <Select.Trigger style={{ width: "100%" }} variant="surface" />
            <Select.Content>
              <Select.Item value="email">Email address</Select.Item>
            </Select.Content>
          </Select.Root>
        }
      />

      {SEVENROOMS_SOURCE_FIELDS.map((field) => {
        const mappedValue = mappings[field.source];
        return (
          <PairRow
            key={field.source}
            left={
              <TextField.Root variant="surface" value={field.label} size="2" disabled style={{ width: "100%" }} />
            }
            right={
              <Select.Root value={mappedValue} disabled size="2">
                <Select.Trigger style={{ width: "100%" }} variant="surface" />
                <Select.Content>
                  <Select.Item value={mappedValue}>{sevenRoomsFieldLabel(mappedValue)}</Select.Item>
                </Select.Content>
              </Select.Root>
            }
          />
        );
      })}
    </div>
  );
}

export function SevenRoomsLocationPair({ left, right }) {
  return (
    <PairRow left={left} right={right} />
  );
}

export function SevenRoomsLocationPairHeaders({ left = "b connect location", right = "SevenRooms venue" }) {
  return (
    <div className="sr-pair sr-pair--head">
      <Text size="2" weight="medium">{left}</Text>
      <span className="sr-pair__arrow" />
      <Text size="2" weight="medium">{right}</Text>
    </div>
  );
}

export function SevenRoomsReadonlyField({ children, title }) {
  return (
    <div className="sr-readonly" title={title}>
      <Text
        size="2"
        title={title}
        style={{
          textOverflow: "ellipsis",
          overflow: "hidden",
          whiteSpace: "nowrap",
          width: "100%",
          color: "var(--gray-a11)",
        }}
      >
        {children}
      </Text>
    </div>
  );
}
